var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.0661C12.915 10.6511 12.915 11.5961 13.5 12.1811L19.32 18.0011L13.5 23.8211C12.915 24.4061 12.915 25.3511 13.5 25.9361C14.085 26.5211 15.03 26.5211 15.615 25.9361L22.5 19.0511C23.085 18.4661 23.085 17.5211 22.5 16.9361L15.615 10.0511C15.045 9.48113 14.085 9.48113 13.5 10.0661Z",
    fill: "#2D2322"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default __webpack_public_path__ + "static/media/icon-chevron-right.25e013c0cd36338282ebfbac47fdb95b.svg";
export { ForwardRef as ReactComponent };